import React, { Component } from 'react'

import {
    FormControl,
    FormGroup,
    FormControlLabel,
    Checkbox,
    Select,
    MenuItem,
} from '@mui/material'

import { FormInputLabel } from '@/Components/Elements/StyledComponents/Input'
class DefFieldDateSettings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            current_time_as_default:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.current_time_as_default
                    ? this.props.item.settings.current_time_as_default
                    : null,
            withtime:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.withtime
                    ? this.props.item.settings.withtime
                    : null,
            restriction:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.restriction
                    ? this.props.item.settings.restriction
                    : null,
            restrict_days:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.restrict_days &&
                Array.isArray(this.props.item.settings.restrict_days)
                    ? this.props.item.settings.restrict_days
                    : [],
        }

        this.onChange = this.onChange.bind(this)
        this.onChangeDay = this.onChangeDay.bind(this)
    }

    onChange(event) {
        if (event.target.getAttribute('type') === 'checkbox') {
            this.props.onChange(event.target.name, event.target.checked)
            this.setState({ [event.target.name]: event.target.checked })
            return
        }
        this.props.onChange(event.target.name, event.target.value)
        this.setState({ [event.target.name]: event.target.value })
    }

    onChangeDay(e) {
        let days = this.state.restrict_days
        days = days.filter((item) => item !== e.target.value)
        if (e.target.checked) {
            days.push(e.target.value)
        }

        this.props.onChange(e.target.name, days)
        this.setState({ restrict_days: days })
    }

    render() {
        const { kedo } = this.props
        const {
            withtime,
            current_time_as_default,
            restriction,
            restrict_days,
        } = this.state
        const days = [
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
            'Sunday',
        ]

        return (
            <div>
                <h3>{this.props.kedo.t('Settings')}</h3>
                <FormControl fullWidth margin="normal">
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={withtime}
                                onChange={this.onChange}
                                name="withtime"
                                size="small"
                            />
                        }
                        label={kedo.t('With time')}
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={current_time_as_default}
                                onChange={this.onChange}
                                name="current_time_as_default"
                                size="small"
                            />
                        }
                        label={kedo.t('Use current date/time as default value')}
                    />
                </FormControl>
                <hr />
                <FormControl fullWidth margin="normal">
                    <FormInputLabel>
                        {kedo.t('Restrict calendar selection')}
                    </FormInputLabel>
                    <Select
                        value={restriction}
                        onChange={this.onChange}
                        name="restriction"
                        fullWidth
                        size="small"
                    >
                        <MenuItem value="none">{kedo.t('None')}</MenuItem>
                        <MenuItem value="before_and_eq_current_date">
                            {kedo.t('Before and equal to the current date')}
                        </MenuItem>
                        <MenuItem value="after_and_eq_current_date">
                            {kedo.t('After and equal to the current date')}
                        </MenuItem>
                    </Select>
                </FormControl>
                <hr />
                <FormControl fullWidth margin="normal">
                    <FormInputLabel>
                        {kedo.t('Only allow selected days')}
                    </FormInputLabel>
                    <FormGroup row>
                        {days.map((day, index) => (
                            <FormControlLabel
                                key={index}
                                control={
                                    <Checkbox
                                        checked={restrict_days.includes(
                                            index.toString()
                                        )}
                                        onChange={this.onChangeDay}
                                        name="restrict_days"
                                        value={index.toString()}
                                        size="small"
                                    />
                                }
                                label={kedo.t(`days_full.${day}`)}
                            />
                        ))}
                    </FormGroup>
                </FormControl>
            </div>
        )
    }
}

export default DefFieldDateSettings
